import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ReportAbuseRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ReportAbuseResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const reportAbuse = (request: ReportAbuseRequest, options?: CashRequestOptions) =>
  post<ReportAbuseRequest, ReportAbuseResponse>('/2.0/cash/report-abuse', request, { ...options, rejectOnError: true })
